import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  ViewEncapsulation,
  inject,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FindingDto } from '@interfaces/partner-income-tax/responses/partner-income-tax.response';
import { TranslateService } from '@ngx-translate/core';
import { VaultBaseComponent } from '@shared/components/base/vault-base.component';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { SharedModule } from '@shared/shared.module';
import { first } from 'rxjs';
import { PartnerIncomeTaxStateService } from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/partner-income-tax-state.service';

/** Dispensar um ponto de atenção do sócio com motivo (exige `PARTNERINCOMETAX_UPDATE`). */
@Component({
  selector: 'app-pit-dismiss-finding-dialog',
  standalone: true,
  imports: [FormsModule, SharedModule],
  templateUrl: './dismiss-finding-dialog.component.html',
  styleUrl: './dismiss-finding-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Com appendTo="body" o estilo precisa ser global; o SCSS escopa tudo pela classe da modal.
  encapsulation: ViewEncapsulation.None,
})
export class DismissFindingDialogComponent extends VaultBaseComponent {
  @ViewChild('dialog') dialogRef: DialogComponent | null = null;

  private readonly state = inject(PartnerIncomeTaxStateService);

  protected readonly finding = signal<FindingDto | null>(null);
  protected reason = '';
  protected readonly submitting = signal(false);

  constructor() {
    super(inject(TranslateService));
  }

  open(finding: FindingDto): void {
    this.finding.set(finding);
    this.reason = '';
    this.dialogRef?.open('', '', '', 'Cancelar', '', 'pit-dismiss-finding', false, false);
  }

  isFormValid(): boolean {
    return this.reason.trim().length >= 5;
  }

  submitAction(): void {
    const finding = this.finding();
    if (!finding || !this.isFormValid() || this.submitting()) return;
    this.submitting.set(true);
    // Ponto agrupado (ex.: IRS-E3 + IRS-G4 sobre o mesmo bem): a dispensa vale para o ponto principal, o primeiro.
    this.state
      .dismissFinding(finding.pointIds[0], this.reason.trim())
      .pipe(first())
      .subscribe(ok => {
        this.submitting.set(false);
        if (ok) this.dialogRef?.close();
      });
  }
}
